import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

import SimpleA from '../display/SimpleAnchor'
import SimpleLink from '../display/SimpleLink'

const Message = styled.p`
  ${typeStyle('-ds-font-body-sm-regular')}
  text-align: center;
  margin: auto;
  line-height: 1.5;

  color: ${({ theme }) => theme?.['-ds-core-100']?.value};
  ${SimpleA}, ${SimpleLink} {
    color: ${({ theme }) => theme?.['-ds-core-100']?.value};
  }
`

const Outer = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 12px 24px;

  background-color: ${({ theme }) => theme?.['-ds-core-300']?.value};
`

const Banner: FC<PropsWithChildren> = ({ children }) => (
  <Outer>
    <Message>{children}</Message>
  </Outer>
)

export default Banner
